var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFacebookOval(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFacebookOval") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "connect-with-facebook",
    transform: "translate(-247.000000, -176.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icFacebookOval",
    transform: "translate(247.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-18",
    fill: "#4E71A8",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.333333,40.8946884 L54.0860804,40.8946884 L54.0860804,33.6602562 C54.0860804,31.663553 55.7065932,30.0430402 57.7032964,30.0430402 L61.3205125,30.0430402 L61.3205125,21 L54.0860804,21 C48.0923533,21 43.2344321,25.8579212 43.2344321,31.8516482 L43.2344321,40.8946884 L36,40.8946884 L36,49.9377286 L43.2344321,49.9377286 L43.2344321,78.8754571 L54.0860804,78.8754571 L54.0860804,49.9377286 L61.3205125,49.9377286 L62.333333,40.8946884 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebookOval);
export default __webpack_public_path__ + "static/media/icFacebookOval.58b71e2a8bf9ac01704c2b65478c0eb6.svg";
export { ForwardRef as ReactComponent };